import React from 'react';
import PropTypes from 'prop-types';
import defaultStyles from 'commonStyles/components/coupon/_loyalty-simplified';
import styleOverrides from 'styles/components/coupon/_loyalty-simplified';
import useStyleOverrides from 'common/components/hooks/use-style-overrides';
import Button from 'common/components/atoms/button';
import ErrorBox from './coupon-error-box';
import { translate } from 'common/localization';

const LoyaltyCouponSimplifiedMember = ({
  disclaimers,
  bodyText,
  claimCoupon,
  isLoading,
  error,
}) => {
  const styles = useStyleOverrides(defaultStyles, styleOverrides);

  const hasError = Object.keys(error).length > 0;

  return (<>
    <p className={styles.couponDescription}>
      {bodyText.member}
    </p>
    {hasError ? (
      <ErrorBox title={error.title} description={error.description} className={styles.errorBox} />
    ) : null}
    <Button
      onClick={claimCoupon}
      className={styles.modalJoinBtn}
      primary
      disabled={isLoading || hasError}
    >
      {isLoading ? (
        <div className="loading-primary" />
      ) : (
        <span>{translate('label.apply.discount')}</span>
      )}
    </Button>
    <div className={styles.disclaimer}>
      <span className={styles.disclaimerText}>
        {disclaimers.member}
      </span>
    </div>
    </>
  );
};

LoyaltyCouponSimplifiedMember.propTypes = {
  disclaimer: PropTypes.shape({}),
  bodyText: PropTypes.shape({}),
  claimCoupon: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  error: PropTypes.shape({}).isRequired,

};

export default LoyaltyCouponSimplifiedMember;
